import { useQuery } from "@apollo/client";

import useTypedContext from "hooks/useTypedContext";
import { isSaasDistribution } from "utils/distribution";
import { AccountContext } from "views/AccountWrapper";

import { GET_ACCOUNT_DELETION_DATA } from "./gql";
import { useToggleAccountDeletionMark } from "./mutations";

const isSaas = isSaasDistribution();

export const useAccountDeletion = () => {
  const { viewer } = useTypedContext(AccountContext);

  // Only load account deletion data for SaaS admin users
  const isAvailable = isSaas && viewer.admin;

  const { data } = useQuery(GET_ACCOUNT_DELETION_DATA, {
    skip: !isAvailable,
  });

  const [toggleAccountDeletionMark, { loading: loadingMarking }] = useToggleAccountDeletionMark({
    refetchQueries: [{ query: GET_ACCOUNT_DELETION_DATA }],
  });

  const toggleForDeletionMark = () => {
    if (!isAvailable) {
      return;
    }

    toggleAccountDeletionMark({});
  };

  return {
    accountCanBeDeleted: data?.accountCanBeDeleted ?? false,
    accountCanBeDeletedAt: data?.accountCanBeDeletedAt ?? null,
    markedForDeletion: data?.markedForDeletion ?? false,
    toggleForDeletionMark,
    loadingMarking,
    isAccountDeletionAvailable: isAvailable && data !== undefined,
  };
};
